<!-- NavBar.vue -->
<template>
  <nav>
    <button @click="$emit('closeNav')" class="btn-close">←</button>
    <img :src="lawraLogoLettersPath" alt="law-ra 로고" class="nav-logo" />
    <button id="new-chat-button" @click="addNewChat">+ New Chat</button>
    <br />
    <h2>History</h2>
    <hr />
    <ol id="chat-hists">
      <li
        v-for="hist in chatHist"
        :key="hist.uuid"
        :class="['chat-hist', { selected: hist.uuid == selectedHistUUID }]"
        @click="selectHist(hist.uuid)"
      >
        {{ hist.content }}
      </li>
    </ol>
    <section id="nav-footer">
      <!-- <div id="my-account">
        <img id="user-icon" :src="userIconPath" alt="상용자 아이콘" />
        <div id="user-name">임시 사용자</div>
      </div> -->
    </section>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      userIconPath: require('@/assets/icons/user_icon_default.png'),
      lawraLogoLettersPath: require('@/assets/icons/lawra_logo_letters.png'),
      /** 대화내역을 바인딩하는 변수. 대화내역은 최신 대화내역이 앞쪽에 배치됩니다. Ex. [대화내역1, 대화내역0] */
      chatHist: [],
      /** uuid 목록 집합 */
      uuidSet: new Set(),
      /** 현재 선택된 hist의 uuid */
      selectedHistUUID: '',
    };
  },
  watch: {
    // selectedHistUUID가 변하면 app.vue에 업데이트
    selectedHistUUID() {
      this.$emit('update:selectedHistUUID', this.selectedHistUUID);
    },
  },
  /** 컴포넌트 생성시 초기 대화내역 생성 및 selectedHistUUID 적용 */
  created() {
    this.chatHist.unshift({ uuid: this.generateUUID(), content: '대화내역 0' });
    this.selectedHistUUID = this.chatHist[0].uuid;
  },
  methods: {
    addNewChat() {
      const newChat = {
        uuid: this.generateUUID(),
        content: `대화내역 ${this.chatHist.length}`,
      };
      this.chatHist.unshift(newChat);
      this.selectedHistUUID = this.chatHist[0].uuid;
    },
    selectHist(uuid) {
      this.selectedHistUUID = uuid;
    },
    /**
     * 대화내역에 UUID를 만들기위해 랜덤 3자리 문자열을 생성하는 함수.
     * _generateUUID로 생성한다음 충돌을 방지하기위해 고유한 문자열이 나올때까지 반복
     */
    generateUUID() {
      let newHash;
      do {
        newHash = this._genenrateUUID();
      } while (this.uuidSet.has(newHash));
      this.uuidSet.add(newHash);
      return newHash;
    },
    _genenrateUUID() {
      const chars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 3; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
  },
};
</script>

<style scoped>
nav {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  position: relative;
  background-color: #f3f3ee;
  font-size: 15px;
  width: 180px;
  min-width: 100px;
  height: 100%;
  padding: 0px 10px;
  flex-shrink: 0.1;
}
.btn-close {
  border: none;
  border-radius: 50%;
  font-size: 25px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 15px;
  z-index: 1;
}
.btn-close:hover {
  background-color: lightgray;
}
.btn-close:active {
  background-color: gray;
}
.nav-logo {
  width: 60%;
  align-items: center;
  margin: 20px auto;
}
#new-chat-button {
  background-color: white;
  font-size: 15px;
  border: none;
  border-radius: 2px;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
}
nav h2 {
  color: #8e8c8c;
  list-style-type: none;
  font-size: 1em;
  padding: 15px 8px;
}
#chat-hists {
  list-style-type: none;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  /* height: 70%; */
}
.chat-hist {
  color: #484848;
  font-size: 0.8em;
  padding: 8px;
}
#nav-footer {
  margin-top: 5px;
  margin-bottom: 15px;
}
#my-account {
  display: flex;
  align-items: center;
  padding: 5px;
}
#user-icon {
  width: 20%;
  flex-shrink: 0;
}
#user-name {
  flex-grow: 1;
  text-align: left;
  font-size: 1em;
  padding: 5px;
}
:is(#my-account, .chat-hist):not(.selected):hover {
  background-color: #dddddd;
  border-radius: 5px;
}
.chat-hist.selected {
  background-color: #bbbbbb;
  border-radius: 5px;
}

@media screen and (max-width: 767px) {
  nav {
    position: absolute;
    left: 0;
    top: 0;
  }
}
@media screen and (min-width: 768px) {
  nav {
    display: flex !important;
  }
  .btn-close {
    display: none;
  }
}
</style>
